module.exports = __webpack_public_path__ + "img/room.eef3dbce.gif";